<template>
    <modal v-if="editUserInfoModal" class="updateProfileModal">
        <div slot="closeModal" @click="editUserInfoModal=!editUserInfoModal">
             <img src="../../assets/icon/close-gray.svg" />
        </div>
        <h3 slot="header"></h3>
        <div slot="body">
            <form>
                <div class="upload-profile-file">
                    <div class="upload-profile-banner">
                        <img v-if="userData && userData.coverphoto" :src="require(`@/assets/images/users/${userData.coverphoto}`)" alt="images" />
                        <div class="cloud-upload">
                            <img src="../../assets/icon/cloud-upload.svg" alt="cloud-upload">
                            <h3>Change Photo</h3>
                        </div>
                    </div><!-- /. upload-profile-banner -->
                    <div class="upload-profile-pic">
                        <img v-if="userData && userData.coverphoto" :src="require(`@/assets/images/users/${userData.photo}`)" alt="images" />
                        <div class="cloud-upload">
                            <img src="../../assets/icon/upload-camera.svg" alt="upload-camera">
                            <h3>Change</h3>
                        </div>
                    </div>
                </div><!-- /. upload-profle-file -->

                <div class="profile-info-update">
                    <div class="row mb-3">
                        <div class="col-md-6 col-sm-12">
                            <div class="form-group">
                                <label for="full_name">Full Name</label>
                                <input id="full_name" type="text" name="full_name" class="form-control" v-model="userData.name" placeholder="Full Name" />
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="form-group">
                                <label for="username">Username</label>
                                <input id="username" type="text" name="full_name" class="form-control" v-model="userData.username" placeholder="Username" />
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="description">Description</label>
                                <textarea id="description" class="form-control" placeholder="Description" v-model="userData.description"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-12">
                            <label for="description">Social Media</label>

                            <div class="single-social-media" v-for="(data, key) in selectSocial" :key="key">
                                <social-media-select :media="data.title"></social-media-select>
                                <input type="text" name="social-media" placeholder="Enter your profile link " v-model="data.link">
                                <button v-if="selectSocial.length>1" class="remove-media" type="button" @click="removeMedia(key)">
                                    <img src="../../assets/icon/close-gray.svg" />
                                </button>
                            </div> <!-- /. single-social-media -->
                            <button type="button" class="add-more-media" @click="addMedia()">Add more <span>+</span></button>
                        </div>
                    </div>
                </div><!-- /. profile-info-update -->
            </form>
        </div>
        <div slot="footer">       
            <button class="profile modal-default-button" @click="saveData()">Save</button>
        </div>
    </modal>
</template>


<script>

import { EventBus } from '../../main';
export default {
    name: "profile-edit-modal",
    props:['userData'],
    data() {
      return {            
        editUserInfoModal:false,
        selectSocial:[
            {
                title: 'facebook',
                link:'https://www.facebook.com/shuvo.sutradhar.3',
            }
        ]
      }
    }, 

    methods: {
        addMedia() {
            this.selectSocial.push({
                title:'facebook',
                link:''
            })
        },

        removeMedia(key){
            this.selectSocial.splice(key, 1);
        },

        saveData() {
            this.editUserInfoModal=false;
            this.$noty.success("Profile has been updated successfully.");
        }

    },


    created() {
        // Update User Info Modal
        EventBus.$on('updateInfo', data => {
            this.editUserInfoModal=data;
        });
    }

}

</script>